import {createApp} from 'vue';

const $JQ = jQuery;
const actClass = 'active';

(function($){
  $.fn.addAccess = function( options ) {
    var settings = $.extend({
      //default settings
      role: 'button',
      tabindex: '0'
    },options);
    
    $(this).attr('tabindex', settings.tabindex).attr('role', settings.role).on('keyup.access', function(e){
      var keyCode = e.which;
      if ((keyCode === 13) || (keyCode === 32)) {
        $(this).click();
      }
    });

    return(this);
  };
  
  $.fn.removeAccess = function() {
    $(this).removeAttr('tabindex').removeAttr('role').off('keyup.access');

    return(this);
  };
})($JQ);


//Menu building for mobile and desktop, using breakdance
(function($){
  $(function(){
    var $doc = $(document),
        $html = $('html'),
        $body = $('body'),
        $window = $(window),
        $mainMenu = $('#zn-main-menu'),
        $menuBtn = $('#zn-menu-button'),
        $mainNav = $('#zn-main-nav'),
        $menuLinks = $('#zn-nav-links'),
        $menuPanel = $('#zn-main-menu .zn-menu-tab').next('.zn-menu-panel'),
        $menuTab = $menuPanel.prev('a'),
        $childNav = $('.zn-child-nav'),
        $sectionMenu = $('.zn-section-menu'),
        $siteSearch = $('#zn-site-search'),
        $siteSearchInput = $('#search-text-input'),
        $searchBtn = $('#zn-menu-search');

      /** Setting up the Menu Text for Mobile */
      if ($childNav.length){
        var sectionMenuTitle = $sectionMenu.find('.zn-child-nav a.parent-page').text();
      }

    //generate the aria controls for each menu panel 
    var menuButtonAddAccess = function(){
      $menuTab.each(function(ind, el){
        var $targetPanel = $(el).siblings('.zn-menu-panel');
        if ($targetPanel.length){
          $targetPanel.attr('id', 'zn-menu-subpanel-'+ind);
          $(el).attr('aria-controls', 'zn-menu-subpanel-'+ind);
        }
      })
    },
    
    /** Function for Expanding the search form on button click **/
    expandSearch = function(){
      //start nonexpanded
      $searchBtn.removeClass(actClass);
      $siteSearch.removeClass(actClass);
      $searchBtn.on('click.expandSearch', function(e){
        e.preventDefault();
        e.stopPropagation();

        var $this = $(this);

        //toggle button
        $this.toggleClass(actClass).attr('aria-expanded', function(index, attr) {
          return attr == 'true' ? 'false' : 'true';
        });

        //toggle search form
        $siteSearch.toggleClass(actClass);

        //add key and click listeners for closing search
        if ($this.hasClass(actClass)){
          //esc key press
          $doc.keydown(function(e){
            if (e.which == 27){
              hideMenuSearch();
            }
          });

          //click outside of search when active
          $doc.one('click.closeSearch', function closeSearch(e){
            if ($siteSearch.has(e.target).length === 0 && $siteSearchInput.has(e.target).length === 0) {
              hideMenuSearch();
            } else if ($siteSearch.hasClass('active')) {
              $doc.one('click', closeSearch);
            }
          });
        }
        });
    },
    /** Functions for moving the search form **/
    moveSearchAboveNav = function(){
      $siteSearch.detach().prependTo($mainNav);
    },
    moveSearchToAfterNav = function(){
      $siteSearch.detach().insertAfter($menuLinks);
    },
    
    /** Functions for add/removing search button functionality and moving the search form **/
    enableMenuSearch = function(){
      hideMenuSearch();
      expandSearch();
      menuSearchFocusOut();
    },

    disableMenuSearch = function(){
      hideMenuSearch();
      $siteSearch.off('focusout')
      $searchBtn.off('click.expandSearch');
    },

    /** Hide search if tabbed out or focused out
     * Has two different directions to check for - pass the search or to previous nav menu items
     * Also works to hide when using click
     *  **/
     menuSearchFocusOut= function(){
      //check if tabbing pass search
      $($siteSearch).focusout(function() {
        setTimeout(function(){
          if ($siteSearch.has(document.activeElement).length == 0 && !$searchBtn.is(document.activeElement)){
            hideMenuSearch();
          }
        }, 0);
      });

      //check if tabbing back to menu
      $($searchBtn).focusout(function(){
        //only care if search is toggled
        if($siteSearch.hasClass(actClass)){
          setTimeout(function(){
            if ($siteSearch.has(document.activeElement).length == 0){
              hideMenuSearch();
            }
          }, 0);
        }
      });
    }, 

    //for hiding the search dropdown
    hideMenuSearch= function(){
      $searchBtn.attr('aria-expanded', 'false');
      $searchBtn.removeClass(actClass);
      $siteSearch.removeClass(actClass);
    },

    //for hiding any subpanels if active. 
    hideSubPanel = function(element){
      $el = $(element);
      if ($el.hasClass(actClass)){
        $el.removeClass(actClass);
        $el.parent("li").removeClass(actClass);
        $el.next().slideToggle('500');
        $el.attr('aria-expanded', 'false');
      }
    },

    /** Hide submenu if tabbed out or focused out **/
    subMenuFocusOut = function(){
      $(".zn-menu-submenu").focusout(function () {
        var $this = $(this);
        setTimeout(function(){
          if ($this.has(document.activeElement).length == 0){
            hideSubPanel($this.children('a'));
          }
        }, 0);
      });
    },

    /** Panel for submenus **/
    expandPanel = function(toggle){
      //start not expanded
      toggle.attr('aria-expanded', 'false');
      toggle.removeClass(actClass);
      subMenuFocusOut();

      
      //click function
      toggle.on('click.exPan', function(e){
        e.preventDefault();
        e.stopPropagation();

        // //hide the search if it's displaying because default is diabled, preventing the search from hiding on click
        // hideMenuSearch();

        var $this = $(this);

        //aria attribute and toggle
        $this.toggleClass(actClass).attr('aria-expanded', function(index, attr) {
          return attr == 'true' ? 'false' : 'true';
        }).next().slideToggle('500').parent("li").toggleClass(actClass);

        //add esc key and click listenrs for closing submenu
        if ($this.hasClass(actClass)){
          //key
          $doc.keydown(function escMenu(e){
            //if check to listener so we don't trigger slidetoggle unnecessarily
              if (e.which == 27){
                hideSubPanel($this);
              }
          });

          //click
          $doc.one('click.closeMenu', function closeMenu(e){
            //if check to listener so we don't trigger slidetoggle unnecessarily
            if ($this.hasClass(actClass)){
              if ($this.has(e.target).length === 0) {
                hideSubPanel($this);
              } else {
                $doc.one('click', closeMenu);
              }
            }
          });
        }
      });
    },

    /** Setting up Menu for mobile **/
    buildMobileMenu = function(){
      $menuBtn.attr('aria-expanded', 'false').attr('aria-controls', 'zn-main-menu').addAccess().on('click.menuExp', function(){
        $(this).toggleClass('zn-opened').attr('aria-expanded', function(index, attr) {
          return attr == 'true' ? 'false' : 'true';
        });
        $mainMenu.slideToggle('500');
      });

      expandPanel($menuTab);
    },

    /** Undo Mobile Menu **/
    destroyMobileMenu = function(){
      $menuBtn.removeAccess().removeAttr('aria-expanded').removeAttr('aria-controls').off('click.menuExp').removeClass('zn-opened');
      $mainMenu.removeAttr('style');
      $menuTab.removeClass(actClass).off('click.exPan').attr('aria-expanded', 'false');
      $menuPanel.hide().parent('li').removeClass(actClass);
    },

    /** Set up for Desktop  Menu **/
    buildDesktopMenu = function(){
      $menuPanel.on('click.ddStopProp', function(e){
        e.stopPropagation();
      });
      expandPanel($menuTab);
    },

    /** Undo desktop menu ***/
    destroyDesktopMenu = function(){
      $menuPanel.off('click.ddStopProp');
      $menuTab.removeClass(actClass).off('click.exPan').attr('aria-expanded', 'false');;
      $doc.off('click.closePan');
      $menuPanel.hide().parent('li').removeClass(actClass);
    },
    buildMobileSectionNav = function(){
      $sectionMenu.prepend('<div class="zn-section-menu-toggle">'+sectionMenuTitle+' Menu</div>');

      var $sectionMenuToggle = $sectionMenu.children('.zn-section-menu-toggle');

      $sectionMenuToggle.addAccess();

      expandPanel($sectionMenuToggle);
    },

    destroyMobileSectionNav = function(){
      $sectionMenu.children('.zn-section-menu-toggle').remove();
      $sectionMenu.children('.zn-section-menu-stage').removeAttr('style');
    };

    var frameworkFunc = [
      {
        min: 0,
        max: 1199,
        enter: function(){
          buildMobileMenu();
          
          if($childNav.length){
            buildMobileSectionNav();
          }

          if($searchBtn.length && $siteSearch.length){
            disableMenuSearch();
          }

          moveSearchAboveNav();
        },
        exit: function(){
          destroyMobileMenu();

          if($childNav.length){
            destroyMobileSectionNav();
          }
        }
      },{
        min: 1200,
        max: 999999,
        enter: function(){
          buildDesktopMenu();
          if($searchBtn.length && $siteSearch.length){
            enableMenuSearch();
          }

          moveSearchToAfterNav();
        },
        exit: function(){
          destroyDesktopMenu();
        }
      }
    ];

    breakdance(frameworkFunc);

    var $postFilters = $('.zn-archive-filter');
    
    if ($postFilters.length) {
      $('.input-daterange').each(function() {
        $(this).datepicker();
      });
    }

    var selectBoxClose = function(i, toggle, panel){
      var container = i;
      $doc.on('click.lsOff', function(e){
        if(!container.is(e.target) && container.has(e.target).length === 0) {
          container.removeClass(actClass).find(panel).slideUp(400);
          container.find(toggle).attr('aria-expanded', 'false'); 
          $doc.off('click.lsOff');
        }
      });
    },
    bindSelectBox = function(selectBox, toggle, panel){
      selectBox.find(toggle).on('click.ls', function(e){
        e.preventDefault();

        var $this = $(this).parent(selectBox),
            $selectBoxStage = $this.find(panel);

        if(!$this.hasClass(actClass)) {
            $(this).attr('aria-expanded', 'true');
            $this.addClass(actClass);
            $selectBoxStage.slideDown(400);
            $doc.trigger('click');             
            selectBoxClose($this, toggle, panel);
          } else {
            $(this).attr('aria-expanded', 'false');
            $this.removeClass(actClass);
            $selectBoxStage.slideUp(400);
            $doc.off('click.lsOff');
          }
      });

      selectBox.find(toggle).addAccess().attr('aria-expanded', 'false');
    };

    var $resourceSearch = $('.zn-resource-search');

    if ($resourceSearch.length) {
      bindSelectBox($('.zn-filter-toggle').parent('.zn-field-group'), '.zn-filter-toggle', '.zn-filter-panel');

      $('.zn-resource-search input[type="checkbox"]').on('change', function(){
        var  $this = $(this),
            labelValue = $this.val();
            labelText = $this.next('label').text(),
            $selectSpan = $('<span class="'+labelValue+' zn-select-text">'+labelText+'</span>'),
            $selectionBox = $this.closest('.zn-filter-panel').prev('.zn-filter-toggle').children('.zn-filter-selection');

          if ($this.is(':checked')) {
            $selectSpan.appendTo($selectionBox);
          } else {
            $selectionBox.find($('.'+labelValue)).remove();
          }
      
          if ($selectionBox.is(':empty') && $selectionBox.is(':visible')){
            $selectionBox.fadeOut('fast');
          } else if (!$selectionBox.is(':empty') && !$selectionBox.is(':visible')) {
            $selectionBox.fadeIn('fast');
          }
      });

      $('.zn-resource-search input[type="checkbox"]').trigger('change');

      $('.school-checkboxes label, .location-checkboxes label').addAccess();
    }

    menuButtonAddAccess();
    $window.trigger('scroll');
  });  
})($JQ);

(function VueComponents($){
  const components = {
    '.vue-expandable-menu' : () => import('./components/ExpandableMenu.vue')
  };

  async function parsePage(){
    Object.keys(components).forEach( async selector => {
      const $els = $(selector).not('[data-vue-init]');
      $els.each( async (i,el) => {
        $(el).attr('data-vue-init', 'true');
        const C = await components[selector]();
        const app = createApp( C.default, {
          html: $(el).html()
        }).mount(el);
      });
    });
  }

  $(parsePage);
  $(window).on('update', parsePage);
})($JQ);

(function SubsiteNavigation($){
   // sidebar nav
  $('.subsite-navigation-toggle').on('click', function() {
    $(this).toggleClass('subsite-navigation-toggle--active');
    $(this).next().toggleClass('subsite-navigation--active');
  });
})($JQ);